import React, { Component } from 'react'; 
import Leftbar from '../components/Leftbar'; 

class Illustration extends Component {
    render(){
        let images = [
            {
                title: "Hilda Season 2", 
                img:"https://cdna.artstation.com/p/assets/images/images/032/988/148/large/jesus-cortes-hilda.jpg?1608067543",
                url: "https://www.instagram.com/p/CIxMtcND6Iu/",
                description: "hilda-season"
            },
            {
                title: "Moon rider", 
                img:"https://cdna.artstation.com/p/assets/images/images/025/285/710/large/jesus-cortes-moon-viewing.jpg?1585293332",
                url: "https://www.instagram.com/p/B-Omg6mDF_m/",
                description: "moon-rider"
            },
            {
                title: "Cartoon Burguer 3D", 
                img:"https://cdna.artstation.com/p/assets/images/images/023/447/094/large/jesus-cortes-final-final-final.jpg?1579222715",
                url: "https://www.instagram.com/p/B7Zo1F_jXbY/",
                description: "cartoon-burguer"
            }
        ]
        return(
            <>
                <Leftbar />
                <div className="container">
                    <div className="row main-section justify-content-md-center align-items-center">
                        {
                            images.map(c =>
                                <div className="col" key={c.description}>
                                    <a href={c.url} className="illustration-link">
                                        <div className="card illustration-card">
                                            <img 
                                                src={c.img} 
                                                className="card-img-top illustration-gallery" 
                                                alt={c.description}
                                            />
                                            <div className="illustration-title">
                                                {c.title}
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            )
                        }
                    </div>
                </div>
            </>
        ); 
    }
}

export default Illustration; 